import { IconButton, Tooltip, Typography } from "@mui/material";
import { useHasPermission } from "../../../api/iam";
import { toTitleCase } from "../../../utils/helperFunctions";
import {
  Archive,
  Biotech,
  Build,
  DeleteForever,
  DoDisturb,
  Error,
  FlightTakeoff,
  NoteAdd,
  VerifiedUser,
} from "@mui/icons-material";
const getActionIcon = (action) => {
  if (action.includes("FAILED")) {
    return <Error />;
  } else if (action.includes("DELETE")) {
    return <DeleteForever />;
  } else if (action.includes("DISCARD")) {
    return <DoDisturb />;
  } else if (action.includes("ARCHIVE")) {
    return <Archive />;
  } else if (action.includes("READY") || action === "MARK_AS_IN_PRODUCTION") {
    return <VerifiedUser />;
  } else if (action.includes("DEPLOY")) {
    return <FlightTakeoff />;
  } else if (action.includes("CREATE")) {
    return <NoteAdd />;
  } else if (action.includes("UNDER")) {
    return <Biotech />;
  } else {
    return <Build />;
  }
};

const ActionButton = ({ action, path, onClick }) => {
  const toShow = useHasPermission(path, "PATCH", action);

  return toShow ? (
    <Tooltip title={<Typography>{toTitleCase(action)}</Typography>}>
      <IconButton onClick={onClick}>{getActionIcon(action)}</IconButton>
    </Tooltip>
  ) : (
    <></>
  );
};

export default ActionButton;
